import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import { IApplicationState } from 'store';
import { popMenuItem, pushMenuItem } from 'store/sidebar/actions';
import { TSidebarAction } from 'store/sidebar/types';

import Sidebar from './sidebar';

interface IDispatchProps {
    pushMenuItem(item: number): void;
    popMenuItem(): void;
}

interface IStateProps {
    isOpen: boolean;
    menuIndexChain: number[];
}

type TSidebarProps = IStateProps;

function mapStateToProps(state: IApplicationState): TSidebarProps {
    const { isOpen, menuIndexChain } = state.sidebar;

    return { isOpen, menuIndexChain };
}

function mapDispatchToProps(dispatch: Dispatch<TSidebarAction>): IDispatchProps {
    return bindActionCreators({
        pushMenuItem,
        popMenuItem
    }, dispatch);
}

export default connect<IStateProps>(mapStateToProps, mapDispatchToProps)(Sidebar);
